// extracted by mini-css-extract-plugin
export default {"primary-font":"Date_primary-font__VzU6W","secondary-font":"Date_secondary-font__QaEkB","virtual-code":"Date_virtual-code__EbJnQ","date":"Date_date__kfz5t","item":"Date_item__XgEss"};